import React from 'react';
import { connect } from 'react-redux';
import { addPesanpribadi } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  addPesanpribadi,
};

function ModalPreview({ addPesanpribadi, data, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const item = data?.item;
  const screenWidth = useScreenWidth();

  function handleSubmit() {
    addPesanpribadi({ auth, history, values: item });
    closeModal();
  }

  return (
    <Modal
      variant='info'
      label='Preview Pesan'
      closeModal={closeModal}
      width={screenWidth > 900 ? 900 : screenWidth}
    >
      <div className='flex justify-around flex-column align-start mx-4'>
        <div className='table-container mt-5 mb-3 mx-1' style={{width: '100%'}}>
          <div className='c-table'>
            <table className='table is-bordered is-striped is-narrow is-hoverable is-fullwidth'>
              <thead>
                <tr>
                  <th className='has-text-centered'>No</th>
                  <th className='has-text-centered'>NIS</th>
                  <th className='has-text-centered'>Nama Siswa</th>
                  <th className='has-text-centered'>Variabel</th>
                  <th className='has-text-centered'>Pesan Pribadi</th>
                </tr>
              </thead>
              <tbody>
                {item?.recipients?.[0] &&
                  item?.recipients?.map((i, key) => (
                    <tr key={key}>
                      <td className='has-text-centered'>
                        {key + 1}
                      </td>
                      <td className='has-text-centered'>
                        {i?.nis}
                      </td>
                      <td>{i?.name}</td>
                      <td>
                        {i?.variable?.[0] &&
                          i?.variable?.map((v, key) => (
                            <span key={key} className='tag mr-1'>
                              {v}
                            </span>
                          ))}
                        {!i?.variable?.[0] && (
                          <div className='has-text-centered'>-</div>
                        )}
                      </td>
                      <td>{i?.messages}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={() => handleSubmit(data)} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalPreview);
